'use client';
import Link from 'next/link';
import { CustomFieldInput, FormRegister } from '@/components/index';
import { FormMessage } from '@/components/ui/form';
import {
    InputOTP,
    InputOTPGroup,
    InputOTPSlot,
} from '@/components/ui/input-otp';
import Cookies from 'js-cookie';
import { LoadingButton } from '@/components/ui/loading-button';
import { useToast } from '@/components/ui/use-toast';
import {
    saveMobile,
    saveName,
    saveRegister,
    setAccessRoute,
    setMobileNot_cookie,
    setPanel,
    setPostion_number_very,
    setPostionForm,
    setStatus,
    setToken,
} from '@/lib/RTK/features/AuthSlice';
import { FaEdit } from 'react-icons/fa';
import { setNameLab_radio } from '@/lib/RTK/features/Single_labSlice';
import { useAppDispatch } from '@/lib/RTK/hooks';
import { axiosClientInstance, baseStaticURL } from '@/lib/servies/axiosConfig';
import { cn } from '@/lib/utils';
import { formShcema } from '@/schema/client/schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';
import Timer from './timer';
import { setShowCityModal } from '@/lib/RTK/features/AdmissionSlice';
import { useMutation } from '@tanstack/react-query';
import { changeCity } from '@/utils/actions/change-city';

export default function LoginFunction({
    style,
    redirect,
    pathNameRoute,
    nameLabRadio,
    endFunction,
    showRegister,
    setShowRegister,
    mainLogin,
}: {
    style?: string;
    redirect?: string;
    pathNameRoute?: string;
    nameLabRadio?: string;
    endFunction?: () => void;
    showRegister?: boolean;
    mainLogin?: boolean;
    setShowRegister?: (val: boolean) => void;
}) {
    type FormSchema = z.infer<typeof formShcema>;
    const [step, setStep] = useState<'numberphone' | 'verifiercode'>(
        'numberphone',
    );
    const [loading, setLoading] = useState(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
        setValue,
        getValues,
        watch,
    } = useForm<FormSchema>({
        resolver: zodResolver(formShcema),
        defaultValues: {
            numberphone: '',
            verifiercode: '',
        },
    });

    const verifycode = watch('verifiercode');
    const phoneNumber = watch('numberphone');
    setValue('redirect', redirect);

    const dispatch = useAppDispatch();
    const { toast } = useToast();
    const router = useRouter();

    const sendMsgHandler = async () => {
        const res1 = await axiosClientInstance.post('/user/send_code', {
            mobile: phoneNumber,
        });

        if (res1.status === 200) {
            toast({
                title: res1.data.message,
                variant: 'success',
            });
            setStep('verifiercode');
            dispatch(setPostion_number_very('very'));
            dispatch(setMobileNot_cookie(Number(phoneNumber)));
        } else {
            toast({
                title: res1.data.message,
                variant: 'error',
            });
        }
    };

    const submitUserCity = useMutation({
        mutationFn: (data: { city_id: string; type: string }) => {
            return fetch(
                `${baseStaticURL}/set_user_city?city_id=${data.city_id}&type=${data.type}`,
                {
                    method: 'POST',
                    headers: {
                        Auth: `Bearer ${Cookies.get('token')}`,
                        'Content-Type': 'application/json',
                    },
                },
            ).then(async (response) => response.json());
        },
        onError: () => {
            toast({
                title: 'فرایند ثبت شهر با شکست مواجه شد',
                variant: 'error',
            });
        },
    });
    const onSubmit: SubmitHandler<FormSchema> = async (data) => {
        setLoading(true);
        try {
            if (step === 'numberphone') {
                sendMsgHandler();
            } else if (step === 'verifiercode') {
                const res2 = await axiosClientInstance.post(
                    '/user/check_code',
                    {
                        mobile: data.numberphone,
                        code: data.verifiercode,
                    },
                );
                dispatch(setToken(res2.data?.token));

                if (res2.data.status === '0') {
                    toast({
                        title: res2.data.message,
                        variant: 'error',
                    });
                    return true;
                } else {
                    toast({
                        title: res2.data.message,
                        variant: 'success',
                    });
                    if (setShowRegister) {
                        setShowRegister(
                            res2.data.register === '0' ? false : true,
                        );
                    }
                    if (res2.data.register === '0') {
                        if (endFunction) {
                            endFunction();
                        }
                        if (
                            res2.data.result?.city_id !== null &&
                            res2.data.result?.city_id !== '0' &&
                            res2.data.result?.province &&
                            res2.data.result?.city
                        ) {
                            const cityId = Cookies.get('cityId');
                            if (!cityId) {
                                changeCity(
                                    String(res2.data.result?.city_id),
                                    `${res2.data.result?.province}-${res2.data.result?.city}`,
                                );
                            }
                        } else {
                            if (mainLogin) {
                                const cityId = Cookies.get('cityId');
                                if (cityId) {
                                    if (Cookies.get('token')) {
                                        submitUserCity.mutate({
                                            city_id: cityId,
                                            type: '1',
                                        });
                                    }
                                } else {
                                    dispatch(setShowCityModal(true));
                                }
                            }
                        }
                        dispatch(saveMobile(res2.data?.result?.mobile));
                        dispatch(saveName(res2.data?.result?.name));
                        dispatch(saveRegister(res2.data?.register));
                        if (res2.data?.matab) {
                            dispatch(setAccessRoute(res2.data?.matab));
                        }
                        if (data.redirect) {
                            const refactorPathName = `token=${res2.data?.token}`;
                            router.replace(data.redirect + refactorPathName);
                        }
                        if (pathNameRoute) {
                            router.push(pathNameRoute);
                            dispatch(setNameLab_radio(nameLabRadio));
                        }
                    } else {
                        dispatch(saveMobile(res2.data?.result?.mobile));
                        dispatch(setPanel(res2.data?.result?.panel));
                        dispatch(setToken(res2.data?.token));
                        dispatch(saveName(res2.data?.result.name));
                        dispatch(setPostionForm('form'));
                        dispatch(setStatus(true));
                        dispatch(saveRegister(res2.data.register));
                    }
                }
            }
        } catch {
            toast({
                title: 'ارتباط برقرار نشد! ',
                variant: 'error',
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setValue('verifiercode', '');

        const ac = new AbortController();
        setTimeout(() => {
            ac.abort();
        }, 2 * 60 * 1000);

        if (step === 'verifiercode') {
            if ('OTPCredential' in window) {
                navigator.credentials
                    .get({
                        otp: { transport: ['sms'] },
                        signal: ac.signal,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any)
                    .then((otp) => {
                        const code =
                            (otp as { code: string } | null)?.code ?? '';

                        setValue('verifiercode', code);

                        setTimeout(() => {
                            if (getValues().verifiercode?.length === 4) {
                                handleSubmit(onSubmit)();
                            }
                        }, 0);
                    })
                    .catch(() => {
                        // toast({
                        //     title: "مشکلی رخ داد.",
                        // });
                    });
            }
        }

        return () => {
            ac.abort();
        };
    }, [step]);

    useEffect(() => {
        return () => {
            dispatch(setPostion_number_very('number'));
        };
    }, []);
    return (
        <>
            {showRegister ? (
                <div className="flex_col w-full gap-6 items-center">
                    <fieldset className="flex_center w-full">
                        <FormRegister
                            className="!grid md:!grid-cols-2 w-full !items-end"
                            redirecTbHomePlus={false}
                            inputStyles="p-2 border-gray-300"
                            onSuccess={() => {}}
                        />
                    </fieldset>
                </div>
            ) : (
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={cn('flex flex-col w-full', style)}
                >
                    {step === 'verifiercode' ? (
                        <div className="flex sm:!flex-row flex-col justify-between items-center">
                            <p className="text-sm w-full sm:!w-max text-[#222222A3] font-medium">
                                کد تایید به شماره {phoneNumber} ارسال شد.
                            </p>
                            <p
                                onClick={() => {
                                    setStep('numberphone');
                                    dispatch(setPostion_number_very('number'));
                                }}
                                className="flex gap-1 sm:!pt-0 pt-2 cursor-pointer items-center font-semibold text-sm text-blue-400"
                            >
                                <FaEdit /> ویرایش شماره
                            </p>
                        </div>
                    ) : (
                        ''
                    )}

                    {step === 'numberphone' && (
                        <div className="w-full flex flex-col">
                            <CustomFieldInput
                                label="شماره موبایل"
                                name="numberphone"
                                type="number"
                                autoFocus
                                errorStyle=" pt-1 block !text-sm"
                                inputmode="numeric"
                                placeholder="0912*******"
                                labelStyle="!relative top-2 bg-white px-1 !w-max font-medium !text-[#222222] !block !text-base"
                                styleInput="text-center placeholder:text-center md:!text-xl !text-[15px] !bg-white placeholder:text-gray-[#999999] !rounded-2xl placeholder:text-sm !outline-0 !ring-0 focus:!border-black !p-3"
                                register={register}
                                error={errors.numberphone}
                                dir="ltr"
                            />
                        </div>
                    )}
                    {step === 'verifiercode' && (
                        <div className="w-full">
                            <p className="text-center md:!pt-0 pt-3 text-[#222222] font-medium pb-1">
                                کد تایید
                            </p>
                            <InputOTP
                                onChange={(v) => {
                                    setValue('verifiercode', v);
                                    setTimeout(() => {
                                        if (
                                            getValues().verifiercode?.length ===
                                            4
                                        ) {
                                            handleSubmit(onSubmit)();
                                        }
                                    }, 0);
                                }}
                                id="verifiercode"
                                maxLength={4}
                                autoFocus
                                value={verifycode}
                            >
                                <InputOTPGroup
                                    className="w-full flex justify-center gap-2"
                                    dir="ltr"
                                >
                                    <InputOTPSlot
                                        className="sm:!size-10 !size-8 !rounded-xl border border-solid border-neutral-300"
                                        autoFocus
                                        index={0}
                                        onFocus={(
                                            e: React.FocusEvent<HTMLDivElement>,
                                        ) => e.target.focus()}
                                    />
                                    <InputOTPSlot
                                        className="sm:!size-10 !size-8 !rounded-xl border border-solid border-neutral-300"
                                        index={1}
                                        onFocus={(
                                            e: React.FocusEvent<HTMLDivElement>,
                                        ) => e.target.focus()}
                                    />
                                    <InputOTPSlot
                                        className="sm:!size-10 !size-8 !rounded-xl border border-solid border-neutral-300"
                                        index={2}
                                        onFocus={(
                                            e: React.FocusEvent<HTMLDivElement>,
                                        ) => e.target.focus()}
                                    />
                                    <InputOTPSlot
                                        className="sm:!size-10 !size-8 !rounded-xl border border-solid border-neutral-300"
                                        index={3}
                                        onFocus={(
                                            e: React.FocusEvent<HTMLDivElement>,
                                        ) => e.target.focus()}
                                    />
                                </InputOTPGroup>
                            </InputOTP>
                            <Timer sendMsgHandler={sendMsgHandler} />
                            <p className="text-base">
                                {errors.verifiercode?.message && (
                                    <FormMessage className="text-xs mt-3 text-red-500">
                                        {errors.verifiercode?.message}
                                    </FormMessage>
                                )}
                            </p>
                        </div>
                    )}
                    {/* {step === 'verifiercode' && (
                <LoadingButton
                    variant={'link'}
                    onClick={() => {
                        setStep('numberphone');
                    }}
                    tabIndex={0}
                >
                    تغییر شماره
                </LoadingButton>
            )} */}
                    <LoadingButton
                        className="bg-blue mt-5 !text-white !h-10 !rounded-2xl"
                        disabled={
                            step === 'verifiercode'
                                ? (verifycode ? verifycode.length < 4 : true) ||
                                  loading
                                : loading
                        }
                        loading={loading}
                        type="submit"
                        size={'sm'}
                    >
                        {step === 'numberphone'
                            ? 'دریافت کدیکبار مصرف'
                            : 'تایید کد'}
                    </LoadingButton>
                    <p className="pt-3 text-center font-medium text-xs sm:!text-sm">
                        با واردکردن کدتایید 
                        <Link
                            prefetch={false}
                            target="_blank"
                            className="text-blue font-bold underline"
                            href="/rules"
                        >
                            قوانین و مقررات درمان شیرین
                        </Link>
                         را می‌پذیرم.
                    </p>
                </form>
            )}
        </>
    );
}
